document.addEventListener('DOMContentLoaded', function () {
  // Don't touch
  // Don't touch
  objectFitImages()
  svg4everybody()
  // End don't touch

  require('./target-blank.js')
  require('./header.js')
  require('./gsap.js')
  require('./show-more.js')
  require('./missing-alts.js')
})

// remove preloader
window.addEventListener('load', function () {
  $('.preloader').fadeOut()
  document.querySelector('html').classList.add('page-loaded')
})
